import { render, staticRenderFns } from "./Oring.vue?vue&type=template&id=285bd793&scoped=true&"
import script from "./Oring.vue?vue&type=script&lang=js&"
export * from "./Oring.vue?vue&type=script&lang=js&"
import style0 from "./Oring.vue?vue&type=style&index=0&id=285bd793&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285bd793",
  null
  
)

export default component.exports